import moment from "moment";

export const removeUserDetailAndOtherDetails = () => {
  localStorage.removeItem("userDetails");
  localStorage.removeItem("apiToken");
  localStorage.removeItem("openStoreId");
  localStorage.removeItem("masterDetailsId");
  localStorage.removeItem("isStoreOpen");
};

export const isOpenStoreIdExist = () => {
  const openStoreId = localStorage.getItem("openStoreId");
  return openStoreId ? true : false;
};

export const navigateTo = (props, path) => {
  if (props) {
    props.history.push(path);
  }
};

export const getInstancedomain = () => {
  let domain =
    // window.location.host === "localhost:3001"
    //   ? "rezlive.sufalam.live"
    //   :
    window.location.host;
  return domain;
};

export const getInstanceurl = () => {
  const instanceUrl = window.location.pathname.split("/")[1];
  return instanceUrl;
};

export function clearLocalStorageReload({ response }) {
  const { error } = response;
  const { statusCode = "" } = error || {};
  if (statusCode === 406) {
    localStorage.clear();
    window.location.reload();
  }
}

export const getCurrentDate = () => {
  const currentDate = moment(new Date()).format("YYYY-MM-DD hh:mm:ss");
  return currentDate;
};

export const getWishListName = (wishlist) => {
  try {
    // Handle array case
    if (Array.isArray(wishlist) && wishlist.length > 0) {
      const [wishlistDefault] = wishlist;
      return (wishlistDefault && wishlistDefault.name) || "";
    }
    // Handle object case
    if (wishlist && typeof wishlist === 'object') {
      return wishlist.name || "";
    }
    return "";
  } catch (error) {
    console.error('Error in getWishListName:', error);
    return "";
  }
};

export const getWishListId = (wishlist) => {
  try {
    if (Array.isArray(wishlist) && wishlist.length > 0) {
      const [wishlistDefault] = wishlist;
      return (wishlistDefault && wishlistDefault.id) || "";
    }
    if (wishlist && typeof wishlist === 'object') {
      return wishlist.id || "";
    }
    return "";
  } catch (error) {
    console.error('Error in getWishListId:', error);
    return "";
  }
};

export const openLinkInNewTab = (path) => {
  const win = window.open(path, "_blank");
  win.focus();
};
